module.exports = __webpack_public_path__ + "static/media/standby-light.4481df7e.png";